import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../firebase';

import { authActions } from '../../store/auth';
import { useAppDispatch } from '../../store/hooks';

import afficheVk from '../../assets/images/affiche-vk.svg';
import afficheAfterwork from '../../assets/images/affiche-afterwork.svg';
import afficheFietstocht from '../../assets/images/affiche-fietstocht.svg';
import Sponsors from '../../components/Sponsors/Sponsors';

import classes from './Home.module.css';

const Home = () => {
  const dispatch = useAppDispatch();

  const afterworkRef = useRef<HTMLDivElement>(null);
  const kermisRef = useRef<HTMLDivElement>(null);
  const fietstochtRef = useRef<HTMLDivElement>(null);

  const scrollToPoster = (ref: React.RefObject<HTMLDivElement>) => {
    if (ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop - 60,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      if (user) {
        dispatch(authActions.login());
      } else {
        dispatch(authActions.logout());
      }
    });
  }, [dispatch]);

  return (
    <>
      <div className={classes.rootContainer}>
        <div className={classes.mainContent}>
          <div className={classes.navButtons}>
            <span className={classes.navLink} onClick={() => scrollToPoster(afterworkRef)}>
              Afterwork
            </span>
            <span className={classes.navLink} onClick={() => scrollToPoster(kermisRef)}>
              Kermis
            </span>
            <span className={classes.navLink} onClick={() => scrollToPoster(fietstochtRef)}>
              Fietstocht
            </span>
          </div>

          <div className={classes.poster} ref={afterworkRef}>
            <Link to="/afterwork">
              <img src={afficheAfterwork} alt="Afterwork" />
            </Link>
          </div>
          <div className={classes.poster} ref={kermisRef}>
            <a href="https://shop.stamhoofd.be/vossingerskermis-2025/" target="_blank" rel="noopener noreferrer">
              <img src={afficheVk} alt="Vossingers Kermis" />
            </a>
          </div>
          <div className={classes.poster} ref={fietstochtRef}>
            <Link to="/fietstocht">
              <img src={afficheFietstocht} alt="Fietstocht" />
            </Link>
          </div>
        </div>
        <Sponsors />
      </div>
    </>
  );
};

export default Home;
